import React, { forwardRef } from "react";

import { cn } from "src/shadcn/lib/utils";
import { Spinner as PrimitiveSpinner } from "src/primitives/Spinner";

export interface SpinnerProps extends React.ComponentProps<
  typeof PrimitiveSpinner
> {
  /** Size variant of the spinner. */
  size?: "sm" | "default" | "lg" | "xl";
  /** Additional CSS class names. */
  className?: string;
}

import { SIZE_CONFIG } from "./constants";

const Spinner = forwardRef<SVGSVGElement, SpinnerProps>(
  ({ size = "default", className, ...otherProps }, ref) => (
    <PrimitiveSpinner
      ref={ref}
      className={cn(SIZE_CONFIG[size], className)}
      {...otherProps}
    />
  )
);

Spinner.displayName = "Spinner";

export { Spinner };
